/* pdpx: mobile swipe product gallery */
!function(){function e(e,t){return(e=(e||"").replace(/^http:/,"https:").replace(/([?&])width=\d+&?/,"$1").replace(/[?&]$/,""))+(e.indexOf("?")>-1?"&":"?")+"width="+t}function t(e){return(e||"").split("?")[0].split("/").pop().replace(/_(\d+x\d*|x\d+)(?=\.)/,"")}function n(){var n=document.getElementById("pdpMedia"),i=document.getElementById("thumbs");if(n&&i&&!n.querySelector(".pdpx-track")){var a=[].slice.call(i.querySelectorAll(".thumb"));if(!(a.length<2)){var r=document.getElementById("pdpImg"),o=r?r.alt:"",d=document.createElement("div");d.className="pdpx-track";var l=document.createElement("div");l.className="pdpx-dots";var c=document.createElement("span");c.className="pdpx-count",a.forEach((function(t,n){var i=t.getAttribute("data-src"),a=document.createElement("div"),r=document.createElement("img");a.className="pdpx-slide",r.src=e(i,900),r.srcset=e(i,600)+" 600w, "+e(i,900)+" 900w, "+e(i,1200)+" 1200w",r.sizes="100vw",r.width=1200,r.height=1200,r.alt=o+" - image "+(n+1),r.loading=n<2?"eager":"lazy",r.decoding="async",r.draggable=!1,a.appendChild(r),d.appendChild(a),l.appendChild(document.createElement("i"))}));var s=document.createElement("button"),u=document.createElement("button");s.type=u.type="button",s.className="pdpx-nav pdpx-prev",u.className="pdpx-nav pdpx-next",s.setAttribute("aria-label","Previous image"),u.setAttribute("aria-label","Next image"),s.innerHTML='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>',u.innerHTML='<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>',n.appendChild(d),n.appendChild(l),n.appendChild(c),n.appendChild(s),n.appendChild(u),n.classList.add("pdpx-on");var p,h=-1,m=a.length,v=l.children;d.addEventListener("scroll",(function(){cancelAnimationFrame(p),p=requestAnimationFrame((function(){var e=d.clientWidth;e&&g(Math.round(Math.abs(d.scrollLeft)/e))}))}),{passive:!0}),a.forEach((function(e,t){e.addEventListener("click",(function(){b(t)}))})),s.addEventListener("click",(function(){b(h-1)})),u.addEventListener("click",(function(){b(h+1)})),r&&window.MutationObserver&&new MutationObserver((function(){for(var e=t(r.getAttribute("src")),n=0;n<m;n++)if(t(a[n].getAttribute("data-src"))===e)return void(n!==h&&b(n))})).observe(r,{attributes:!0,attributeFilter:["src"]}),window.addEventListener("resize",(function(){d.scrollLeft=h*d.clientWidth}));var f=0;a.forEach((function(e,t){e.classList.contains("on")&&(f=t)})),g(f),f&&requestAnimationFrame((function(){b(f,!1)}))}}function g(e){if(!(e<0||e>=m||e===h)){h=e;for(var t=0;t<m;t++)a[t].classList.toggle("on",t===e),v[t].classList.toggle("on",t===e);c.textContent=e+1+" / "+m;var n=a[e];if(i.scrollWidth>i.clientWidth){var r=n.getBoundingClientRect().left-i.getBoundingClientRect().left;i.scrollTo({left:i.scrollLeft+r-(i.clientWidth-n.offsetWidth)/2,behavior:"smooth"})}}}function b(e,t){e=(e+m)%m,d.scrollTo({left:e*d.clientWidth,behavior:!1===t?"auto":"smooth"}),g(e)}}"loading"===document.readyState?document.addEventListener("DOMContentLoaded",n):n()}();
/* Wybeo — Steel & Gold. Motion engine ported from the approved design,
   with the hash router replaced by real Shopify pages and the Ajax cart. */
(function(){
  "use strict";
  var root = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var mode = root.getAttribute("data-mode") || "weight";
  var WY = window.WY || {};
  function $(id){ return document.getElementById(id); }
  function all(sel, ctx){ return [].slice.call((ctx || document).querySelectorAll(sel)); }
  function clamp(v,a,b){ return v<a?a:v>b?b:v; }

  /* ---------------- money ---------------- */
  function money(cents){
    var v = Math.round(cents) / 100;
    var s = (v % 1 === 0) ? String(v) : v.toFixed(2);
    return (WY.currency || "AED") + " " + s;
  }

  /* ---------------- toast + cart ---------------- */
  var tt;
  function toast(msg){
    var t = $("toast"); if (!t) return;
    t.textContent = msg; t.classList.add("on");
    clearTimeout(tt); tt = setTimeout(function(){ t.classList.remove("on"); }, 1900);
  }
  function paintCount(n){
    var el = $("cartCount"); if (!el) return;
    el.textContent = n; el.classList.toggle("on", n > 0);
  }
  function addItems(items){
    return fetch((WY.cartAddUrl || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      return r.json().then(function(j){ if (!r.ok) throw j; return j; });
    }).then(function(){
      return fetch((WY.cartUrl || "/cart") + ".js").then(function(r){ return r.json(); });
    }).then(function(c){ paintCount(c.item_count); return c; });
  }
  function busy(btn, on){ if (btn) { btn.classList.toggle("is-busy", on); btn.disabled = on; } }

  document.addEventListener("click", function(ev){
    var add = ev.target.closest("[data-add]");
    if (add) {
      ev.preventDefault();
      var n = 1, box = add.closest(".fbti");
      if (box) { var sp = box.querySelector(".stepper.small span"); n = parseInt(sp && sp.textContent, 10) || 1; }
      busy(add, true);
      addItems([{ id: parseInt(add.getAttribute("data-add"), 10), quantity: n }])
        .then(function(){ toast("Added to cart"); })
        .catch(function(e){ toast((e && e.description) || "Could not add that"); })
        .then(function(){ busy(add, false); });
    }
  });

  /* ---------------- phone menu ---------------- */
  var ov = $("menuOv");
  function menu(open){
    if (!ov) return;
    ov.classList.toggle("open", open);
    ov.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.classList.toggle("menu-open", open);
    var b = $("menuOpen"); if (b) b.setAttribute("aria-expanded", String(open));
    var mp = ov.querySelector(".menupage");
    if (mp) { if (open) requestAnimationFrame(function(){ requestAnimationFrame(function(){ mp.classList.add("in-view"); }); }); else mp.classList.remove("in-view"); }
  }
  if ($("menuOpen")) $("menuOpen").addEventListener("click", function(){ menu(true); });
  if ($("menuClose")) $("menuClose").addEventListener("click", function(){ menu(false); });
  document.addEventListener("keydown", function(e){ if (e.key === "Escape") menu(false); });

  /* ---------------- scroll engine ---------------- */
  var lastY = window.scrollY, vel = 0, raf = false, dir = 1;
  var hdr = $("hdr"), annRow = $("annRow");

  function frame(){
    var y = window.scrollY, dy = y - lastY, vh = window.innerHeight;
    if (Math.abs(dy) > 1) dir = dy > 0 ? 1 : -1;
    vel += (dy - vel) * 0.16;
    if (Math.abs(vel) < 0.08) vel = 0;
    vel = clamp(vel, -70, 70);
    root.style.setProperty("--vel", vel.toFixed(2));
    root.style.setProperty("--vorigin", dir > 0 ? "left" : "right");
    root.classList.toggle("up", dir < 0);

    if (annRow) annRow.style.setProperty("--spd",
      (mode === "velocity" ? clamp(40 - Math.abs(vel) * 0.74, 7, 40) : 40).toFixed(1) + "s");

    if (hdr) {
      hdr.classList.toggle("small", y > 90);
      if (mode === "velocity") hdr.classList.toggle("hide", dir > 0 && y > 480);
      else hdr.classList.remove("hide");
      if (mode === "weight") {
        var over = false, hb = hdr.getBoundingClientRect();
        all("[data-dark]").forEach(function(d){
          var r = d.getBoundingClientRect();
          if (r.top < hb.bottom - 4 && r.bottom > hb.top + 4) over = true;
        });
        hdr.classList.toggle("inv", over);
      } else hdr.classList.remove("inv");
    }

    all("[data-p]").forEach(function(el){
      var b = el.getBoundingClientRect();
      if (b.bottom < -160 || b.top > vh + 160) return;
      el.style.setProperty("--p", clamp((vh - b.top) / (vh + b.height), 0, 1).toFixed(4));
    });

    var colRail = $("colRail");
    if (colRail && !colRail.dataset.drag) {
      var maxX = colRail.scrollWidth - colRail.clientWidth;
      var hpin = $("hpin");
      if (mode === "velocity" && hpin && window.innerWidth > 860) {
        var pr = hpin.getBoundingClientRect(), tot = pr.height - vh;
        colRail.scrollLeft = (tot > 0 ? clamp(-pr.top / tot, 0, 1) : 0) * maxX;
      } else {
        var box = colRail.getBoundingClientRect();
        if (Math.abs(dy) > 0.5 && box.bottom > 0 && box.top < vh) colRail.scrollLeft += dy * 0.55;
      }
      paintRail();
    }

    var vpin = $("vpin");
    if (mode === "weight" && vpin && vpin.classList.contains("is-pinned") && window.innerWidth > 860 && !whyClicked) {
      var items = all(".why2__item");
      var vr = vpin.getBoundingClientRect(), vt = vr.height - vh;
      var vp = vt > 0 ? clamp(-vr.top / vt, 0, 1) : 0;
      var seg = 1 / (items.length || 1);
      var idx = Math.min(items.length - 1, Math.floor(vp / seg));
      setWhy(idx);
      items.forEach(function(it,k){ it.style.setProperty("--prog", (clamp((vp - k*seg)/seg, 0, 1) * 100).toFixed(1) + "%"); });
    }

    var sticky = $("stickyBuy");
    if (sticky) {
      var buy = document.querySelector(".pdp__buy");
      sticky.classList.toggle("on", !!buy && buy.getBoundingClientRect().bottom < 40);
    }
    lastY = y; raf = false;
  }
  function onScroll(){ if (!raf) { raf = true; requestAnimationFrame(frame); } }
  window.addEventListener("scroll", onScroll, { passive:true });
  window.addEventListener("resize", onScroll, { passive:true });
  setInterval(function(){ if (Math.abs(vel) > 0.08) onScroll(); }, 60);

  /* ---------------- How we work ---------------- */
  var whyIdx = -1, whyClicked = false, whyT;
  function setWhy(k){
    if (k === whyIdx) return;
    whyIdx = k;
    all(".why2__item").forEach(function(it,i){
      it.classList.toggle("on", i === k);
      var h = it.querySelector(".why2__head"); if (h) h.setAttribute("aria-expanded", String(i === k));
    });
    all(".why2__slide").forEach(function(sl,i){ sl.classList.toggle("on", i === k); });
    var n = $("whyNow"); if (n) n.textContent = (k + 1 < 10 ? "0" : "") + (k + 1);
  }
  all(".why2__item").forEach(function(it,k){
    var h = it.querySelector(".why2__head");
    if (h) h.addEventListener("click", function(){
      whyClicked = true; clearTimeout(whyT);
      whyT = setTimeout(function(){ whyClicked = false; }, 2500);
      it.style.setProperty("--prog", "100%");
      setWhy(k);
    });
  });
  if (all(".why2__item").length) setWhy(0);

  /* announcement height, so the sticky header section parks the bar off-screen */
  function annH(){ var a = document.querySelector(".ann"); root.style.setProperty("--ann-h", (a && a.offsetParent ? a.offsetHeight : 0) + "px"); }
  annH(); window.addEventListener("resize", annH);

  /* ---------------- reveals, counters, pointer ---------------- */
  var hasIO = "IntersectionObserver" in window;
  var io = hasIO && new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("seen"); io.unobserve(e.target); } });
  }, { threshold:0, rootMargin:"0px 0px -10% 0px" });
  var cio = hasIO && new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (!e.isIntersecting) return;
      var el = e.target, to = parseInt(el.getAttribute("data-to"),10) || 0, t0 = null;
      cio.unobserve(el);
      if (reduce) { el.textContent = to; return; }
      requestAnimationFrame(function run(ts){
        if (!t0) t0 = ts;
        var p = Math.min(1,(ts-t0)/900), e2 = 1 - Math.pow(1-p,3);
        el.textContent = Math.round(to * e2);
        if (p < 1) requestAnimationFrame(run);
      });
    });
  }, { threshold:0, rootMargin:"0px 0px -12% 0px" });
  if (hasIO) {
    var fio = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) e.target.classList.add("seen"); });
    }, { threshold:0, rootMargin:"0px 0px -8% 0px" });
    if ($("foot")) fio.observe($("foot"));
  }

  var cur = $("cur");
  function wire(){
    all("[data-reveal]").forEach(function(el){ if (io) io.observe(el); else el.classList.add("seen"); });
    all(".cnt").forEach(function(el){ if (cio) cio.observe(el); else el.textContent = el.getAttribute("data-to"); });
    all(".tiltable").forEach(function(c){
      c.addEventListener("pointermove", function(ev){
        if (mode !== "velocity") return;
        var b = c.getBoundingClientRect();
        c.style.setProperty("--rx", ((ev.clientX-b.left)/b.width - .5).toFixed(3));
        c.style.setProperty("--ry", ((ev.clientY-b.top)/b.height - .5).toFixed(3));
      });
      c.addEventListener("pointerleave", function(){ c.style.setProperty("--rx",0); c.style.setProperty("--ry",0); });
    });
    all(".labelled").forEach(function(t){
      t.addEventListener("pointerenter", function(){ if (mode === "velocity" && cur) cur.classList.add("on"); });
      t.addEventListener("pointerleave", function(){ if (cur) cur.classList.remove("on"); });
    });
    all(".mag").forEach(function(btn){
      btn.addEventListener("pointermove", function(ev){
        if (mode !== "velocity") return;
        var b = btn.getBoundingClientRect();
        btn.style.transform = "translate(" + ((ev.clientX-b.left-b.width/2)*0.18).toFixed(1) +
          "px," + ((ev.clientY-b.top-b.height/2)*0.26).toFixed(1) + "px)";
      });
      btn.addEventListener("pointerleave", function(){ btn.style.transform = ""; });
    });
  }
  window.addEventListener("pointermove", function(ev){
    if (mode !== "velocity" || !cur) return;
    cur.style.left = ev.clientX + "px"; cur.style.top = ev.clientY + "px";
  }, { passive:true });

  /* ---------- collections rail ---------- */
  function paintRail(){
    var rail = $("colRail"); if (!rail) return;
    var maxX = rail.scrollWidth - rail.clientWidth;
    var bar = $("railBar");
    if (bar && maxX > 0) {
      var frac = rail.clientWidth / rail.scrollWidth;
      bar.style.setProperty("--w", (frac * 100).toFixed(2) + "%");
      bar.style.setProperty("--o", ((rail.scrollLeft / maxX) * ((1 - frac) * 100) / frac).toFixed(2) + "%");
    }
    var prev = $("railPrev"), next = $("railNext");
    if (prev) prev.disabled = rail.scrollLeft < 6;
    if (next) next.disabled = rail.scrollLeft > maxX - 6;
    var mid = rail.getBoundingClientRect().left + rail.clientWidth / 2;
    all(".tile", rail).forEach(function(t){
      var b = t.getBoundingClientRect();
      var d = Math.min(1, Math.abs(b.left + b.width / 2 - mid) / (rail.clientWidth / 2));
      t.style.setProperty("--near", (1 - d * 0.055).toFixed(3));
      t.style.setProperty("--fade", (1 - d * 0.22).toFixed(3));
    });
  }
  function wireRail(){
    var rail = $("colRail"); if (!rail) return;
    rail.addEventListener("scroll", paintRail, { passive:true });
    function step(d){
      var t = rail.querySelector(".tile");
      rail.scrollBy({ left: d * (t ? t.getBoundingClientRect().width + 20 : 300), behavior:"smooth" });
    }
    if ($("railPrev")) $("railPrev").onclick = function(){ step(-1); };
    if ($("railNext")) $("railNext").onclick = function(){ step(1); };
    var down = false, sx = 0, sl = 0, moved = 0;
    rail.addEventListener("pointerdown", function(e){
      if (e.pointerType !== "mouse") return;
      down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft;
      rail.dataset.drag = "1"; rail.classList.add("drag");
    });
    window.addEventListener("pointermove", function(e){
      if (!down) return;
      var d = e.clientX - sx; moved = Math.abs(d);
      rail.scrollLeft = sl - d; paintRail();
    });
    window.addEventListener("pointerup", function(){
      if (!down) return;
      down = false; rail.classList.remove("drag");
      setTimeout(function(){ delete rail.dataset.drag; }, 60);
    });
    rail.addEventListener("click", function(e){ if (moved > 6) { e.preventDefault(); moved = 0; } }, true);
    rail.addEventListener("dragstart", function(e){ e.preventDefault(); });
    paintRail();
  }

  /* ---------- reviews lane ---------- */
  var revX = 0, revLast = 0, revHover = false, revDown = false, revSX = 0, revStart = 0;
  function tickRevs(ts){
    var track = $("revTrack"), rail = $("revRail");
    if (track && rail) {
      var dt = revLast ? Math.min(60, ts - revLast) : 16;
      var half = track.scrollWidth / 2;
      if (!revHover && !revDown && !reduce && half > 0) revX -= (0.035 * dt) + clamp(vel * 0.5, -22, 22) * 0.26;
      if (half > 0) {
        if (revX <= -half) revX += half;
        if (revX > 0) revX -= half;
        track.style.transform = "translateX(" + revX.toFixed(1) + "px)";
        var mid = rail.getBoundingClientRect().left + rail.clientWidth / 2;
        [].forEach.call(track.children, function(c){
          var b = c.getBoundingClientRect();
          if (b.right < -200 || b.left > rail.clientWidth + 200) return;
          var d = Math.min(1, Math.abs(b.left + b.width/2 - mid) / (rail.clientWidth/2));
          c.style.setProperty("--near", (1 - d * 0.045).toFixed(3));
        });
      }
      revLast = ts;
      requestAnimationFrame(tickRevs);
    }
  }
  function wireRevs(){
    var rail = $("revRail"); if (!rail) return;
    rail.addEventListener("pointerenter", function(){ revHover = true; });
    rail.addEventListener("pointerleave", function(){ revHover = false; });
    rail.addEventListener("pointerdown", function(e){ revDown = true; revSX = e.clientX; revStart = revX; rail.classList.add("drag"); });
    window.addEventListener("pointermove", function(e){ if (revDown) revX = revStart + (e.clientX - revSX); });
    window.addEventListener("pointerup", function(){ revDown = false; rail.classList.remove("drag"); });
    requestAnimationFrame(tickRevs);
  }

  /* ---------- product page ---------- */
  function wirePdp(){
    var form = $("pdpForm"); if (!form) return;
    var data = {}; try { data = JSON.parse($("pdpData").textContent); } catch(e) {}
    var variants = data.variants || [];
    var vInput = $("pdpVariant"), qInput = $("pdpQty");
    var stepQ = 1, bundle = $("bundle");
    var current = variants.filter(function(v){ return String(v.id) === vInput.value; })[0] || variants[0];

    function setQty(q){
      stepQ = Math.max(1, q); qInput.value = stepQ;
      if ($("stepVal")) $("stepVal").textContent = stepQ;
      if (bundle) {
        all(".btier", bundle).forEach(function(t){
          var on = parseInt(t.getAttribute("data-q"),10) === stepQ;
          t.classList.toggle("on", on); t.querySelector("input").checked = on;
        });
      }
    }
    if (bundle) all(".btier", bundle).forEach(function(t){
      t.addEventListener("click", function(e){ e.preventDefault(); setQty(parseInt(t.getAttribute("data-q"),10) || 1); });
    });
    all("#stepper [data-step]").forEach(function(btn){
      btn.addEventListener("click", function(){ setQty(stepQ + parseInt(btn.getAttribute("data-step"),10)); });
    });

    function paintVariant(v){
      if (!v) return;
      current = v; vInput.value = v.id;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var off = sale ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) : 0;
      $("pdpPrice").innerHTML = '<span class="now' + (sale ? ' sale' : '') + '">' + money(v.price) + '</span>' +
        (sale ? '<s class="was">' + money(v.compare_at_price) + '</s><span class="offpill">Save ' + off + '%</span>' : '');
      var sb = document.querySelector("[data-sbprice]"); if (sb) sb.textContent = money(v.price);
      if (bundle) all(".btier", bundle).forEach(function(t){
        var q = parseInt(t.getAttribute("data-q"),10), o = parseFloat(t.getAttribute("data-off")) || 0;
        var full = v.price * q, nowp = Math.round(full * (100 - o) / 100); if (t.getAttribute("data-dt") === "flat") nowp = Math.max(0, full - (parseFloat(t.getAttribute("data-flat")) || 0));
 var base = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price * q : full;
 t.querySelector("[data-now]").textContent = money(nowp); var ea = t.querySelector("[data-each]"); if (ea && q > 1) ea.textContent = money(Math.round(nowp / q)) + " each";
 var s = t.querySelector("[data-full]"); if (s) { s.textContent = money(base); s.style.display = base > nowp ? "" : "none"; }
      });
      all("[data-buy],[data-addform],[data-addsticky]").forEach(function(b){
        b.disabled = !v.available;
        var sp = b.querySelector("span");
        if (sp && b.hasAttribute("data-buy")) sp.textContent = v.available ? "Add to cart" : "Sold out";
      });
      if (v.featured_image && $("pdpImg")) showImage(v.featured_image.src);
      if (history.replaceState) history.replaceState({}, "", location.pathname + "?variant=" + v.id);
    }
    all(".opt").forEach(function(opt){
      all(".optv", opt).forEach(function(b){
        b.addEventListener("click", function(){
          all(".optv", opt).forEach(function(x){ x.classList.remove("on"); });
          b.classList.add("on");
          opt.querySelector("[data-optval]").textContent = b.getAttribute("data-val");
          var picked = all(".opt").map(function(o){ var on = o.querySelector(".optv.on"); return on ? on.getAttribute("data-val") : null; });
          var match = variants.filter(function(v){ return picked.every(function(val,i){ return v.options[i] === val; }); })[0];
          paintVariant(match);
        });
      });
    });

    var media = $("pdpMedia");
    function showImage(src){
      var img = $("pdpImg"); if (!img || !src) return;
      media.classList.add("swap");
      setTimeout(function(){
        img.removeAttribute("srcset"); img.src = src.replace(/^http:/, "https:");
        media.classList.remove("swap");
      }, 180);
    }
    all("#thumbs .thumb").forEach(function(btn){
      btn.addEventListener("click", function(){
        all("#thumbs .thumb").forEach(function(b2){ b2.classList.remove("on"); });
        btn.classList.add("on"); showImage(btn.getAttribute("data-src"));
      });
    });

    function addCurrent(btn){
      busy(btn, true);
      return addItems([{ id: current.id, quantity: stepQ }])
        .catch(function(e){ toast((e && e.description) || "Could not add that"); busy(btn, false); throw e; })
        .then(function(c){ busy(btn, false); return c; });
    }
    form.addEventListener("submit", function(ev){
      if (ev.defaultPrevented) return;
      ev.preventDefault();
      var btn = form.querySelector("[data-addform]");
      addCurrent(btn).then(function(){ toast("Added to cart"); }, function(){});
    });
    var buy = form.querySelector("[data-buy]");
    if (buy) buy.addEventListener("click", function(){
      addCurrent(buy).then(function(){ toast("Added to cart"); }, function(){});
    });
    var st = document.querySelector("[data-addsticky]");
    if (st) st.addEventListener("click", function(){ addCurrent(st).then(function(){ toast("Added to cart"); }, function(){}); });

    var eta = $("etaLine");
    if (eta) {
      var d = new Date(), days = WY.offerDays || [2,5];
      var fmt = function(x){ return x.toLocaleDateString("en-GB", { month:"short", day:"numeric" }); };
      eta.innerHTML = 'Order placed on <b>' + fmt(d) + '</b> is processed by <b>' +
        fmt(new Date(d.getTime() + days[0] * 864e5)) + '</b> and reaches you around <b>' +
        fmt(new Date(d.getTime() + days[1] * 864e5)) + '</b>';
    }
  }

  /* small steppers (bought together) */
  all(".stepper.small").forEach(function(sp){
    var val = sp.querySelector("span");
    all("[data-fstep]", sp).forEach(function(btn){
      btn.addEventListener("click", function(){
        val.textContent = Math.max(1, (parseInt(val.textContent,10) || 1) + parseInt(btn.getAttribute("data-fstep"),10));
      });
    });
  });

  /* ---------- auto rails (trust row on phone) ---------- */
function wireAutoRails(){
all("[data-autorail]").forEach(function(el){
if (el.dataset.wired) return; el.dataset.wired = "1";
var ms = parseInt(el.getAttribute("data-autorail"), 10) || 0; if (ms < 1000) return;
var hold = 0;
function pause(){ hold = Date.now() + ms * 2; }
el.addEventListener("touchstart", pause, { passive:true });
el.addEventListener("pointerdown", pause);
el.addEventListener("wheel", pause, { passive:true });
setInterval(function(){
if (Date.now() < hold || reduce) return;
var max = el.scrollWidth - el.clientWidth; if (max < 4) return;
var b = el.getBoundingClientRect(); if (b.bottom < 0 || b.top > window.innerHeight) return;
if (el.scrollLeft >= max - 4) { el.scrollTo({ left: 0, behavior: "smooth" }); return; }
var kids = [].slice.call(el.children), x = el.scrollLeft, target = max;
for (var i = 0; i < kids.length; i++) { if (kids[i].offsetLeft > x + 4) { target = Math.min(max, kids[i].offsetLeft); break; } }
el.scrollTo({ left: target, behavior: "smooth" });
}, ms);
});
}

/* ---------- slideshow ---------- */
function wireSlideshows(){
all("[data-ss]").forEach(function(ss){
if (ss.dataset.wired) return; ss.dataset.wired = "1";
var slides = all(".ss__slide", ss), dots = all(".ss__dots button", ss);
if (!slides.length) return;
var k = 0, auto = ss.getAttribute("data-auto") === "true" && slides.length > 1 && !reduce;
var ms = parseInt(ss.getAttribute("data-int"), 10) || 5000, t = null, paused = false;
ss.style.setProperty("--ss-int", ms + "ms");
if (auto) ss.classList.add("is-auto");
function vids(){
slides.forEach(function(s, i){
all("video", s).forEach(function(v){ if (i === k) { try { v.currentTime = 0; var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); } catch(e){} } else { try { v.pause(); } catch(e){} } });
});
}
function go(n){
k = (n + slides.length) % slides.length;
slides.forEach(function(s, i){ s.classList.toggle("on", i === k); s.setAttribute("aria-hidden", i === k ? "false" : "true"); });
dots.forEach(function(d, i){ d.classList.remove("on"); void d.offsetWidth; d.classList.toggle("on", i === k); });
vids(); arm();
}
function arm(){ clearTimeout(t); if (auto && !paused) t = setTimeout(function(){ go(k + 1); }, ms); }
dots.forEach(function(d, i){ d.addEventListener("click", function(){ go(i); }); });
var p = ss.querySelector(".ss__arw.prev"), n = ss.querySelector(".ss__arw.next");
if (p) p.addEventListener("click", function(){ go(k - 1); });
if (n) n.addEventListener("click", function(){ go(k + 1); });
if (ss.getAttribute("data-hoverpause") === "true") {
ss.addEventListener("pointerenter", function(e){ if (e.pointerType === "mouse") { paused = true; ss.classList.add("is-paused"); clearTimeout(t); } });
ss.addEventListener("pointerleave", function(e){ if (e.pointerType === "mouse") { paused = false; ss.classList.remove("is-paused"); arm(); } });
}
var sx = null, sy = 0;
ss.addEventListener("touchstart", function(e){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive:true });
ss.addEventListener("touchend", function(e){
if (sx === null) return;
var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(k + (dx < 0 ? 1 : -1));
}, { passive:true });
go(0);
});
}

/* ---------- mouse drag for swipe rows ---------- */
function wireDrag(){
all("[data-drag]").forEach(function(el){
if (el.dataset.dwired) return; el.dataset.dwired = "1";
var down = false, sx = 0, sl = 0, moved = 0;
el.addEventListener("pointerdown", function(e){ if (e.pointerType !== "mouse") return; down = true; moved = 0; sx = e.clientX; sl = el.scrollLeft; el.classList.add("drag"); });
window.addEventListener("pointermove", function(e){ if (!down) return; var d = e.clientX - sx; moved = Math.abs(d); el.scrollLeft = sl - d; });
window.addEventListener("pointerup", function(){ if (!down) return; down = false; el.classList.remove("drag"); });
el.addEventListener("click", function(e){ if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
el.addEventListener("dragstart", function(e){ e.preventDefault(); });
});
}

/* ---------- product videos: play in view, tap to pause, sound, progress, centre focus ---------- */
function wireVideos(){
all(".pvids").forEach(function(rail){
if (rail.dataset.vwired) return; rail.dataset.vwired = "1";
var auto = rail.getAttribute("data-pv-auto") !== "false";
var cards = all(".pvid", rail);
function focus(){
if (!rail.classList.contains("is-center")) return;
var r = rail.getBoundingClientRect(), mid = r.left + r.width / 2, best = null, bd = 1e9;
var over = rail.scrollWidth - rail.clientWidth > 6;
cards.forEach(function(c){
var b = c.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - mid);
if (d < bd) { bd = d; best = c; }
var f = over ? Math.min(1, d / (r.width / 1.6)) : 0;
c.style.setProperty("--pv-s", (1 - f * .08).toFixed(3));
c.style.setProperty("--pv-o", (1 - f * .35).toFixed(3));
});
cards.forEach(function(c){ c.classList.toggle("is-active", c === best && over); });
}
rail.addEventListener("scroll", function(){ requestAnimationFrame(focus); }, { passive:true });
window.addEventListener("resize", focus); setTimeout(focus, 300); focus();
cards.forEach(function(card){
var v = card.querySelector("video"); if (!v) return;
v.muted = true; v.setAttribute("muted", ""); v.setAttribute("playsinline", ""); v.removeAttribute("controls");
var bar = card.querySelector(".pvid__prog i"), userPaused = false;
function play(){ var p = v.play(); if (p && p.catch) p.catch(function(){}); }
v.addEventListener("play", function(){ card.classList.add("is-playing"); });
v.addEventListener("pause", function(){ card.classList.remove("is-playing"); });
v.addEventListener("timeupdate", function(){ if (bar && v.duration) bar.style.setProperty("--t", (v.currentTime / v.duration).toFixed(3)); });
if (auto && "IntersectionObserver" in window) {
new IntersectionObserver(function(es){ es.forEach(function(e){
if (e.isIntersecting && !userPaused) play(); else if (!e.isIntersecting) v.pause();
}); }, { threshold: .45 }).observe(v);
}
card.querySelector(".pvid__m").addEventListener("click", function(e){
if (e.target.closest(".pvid__snd")) return;
if (rail.classList.contains("drag")) return;
if (v.paused) { userPaused = false; play(); } else { userPaused = true; v.pause(); }
});
var b = card.querySelector(".pvid__snd");
if (b) b.addEventListener("click", function(e){
e.stopPropagation();
var turnOn = v.muted;
all(".pvid video").forEach(function(o){ o.muted = true; var ob = o.parentNode.querySelector(".pvid__snd"); if (ob) ob.classList.remove("is-on"); });
v.muted = !turnOn; b.classList.toggle("is-on", turnOn);
if (turnOn) { userPaused = false; play(); }
});
});
});
}
document.addEventListener("click", function(e){
var a = e.target.closest("[data-tobuy]"); if (!a) return;
var t = document.getElementById("pdp"); if (!t) return;
e.preventDefault(); t.scrollIntoView({ behavior: "smooth", block: "start" });
});

/* ---------- read more ---------- */
function wireClamp(){
all("[data-clamp]").forEach(function(box){
if (box.dataset.wired) return; box.dataset.wired = "1";
var inner = box.querySelector(".clampbox__in"), btn = box.querySelector(".clampbox__btn");
function check(){
if (box.classList.contains("open")) return;
var lim = parseFloat(getComputedStyle(inner).maxHeight) || 0;
box.classList.toggle("short", inner.scrollHeight <= lim + 60);
}
check(); window.addEventListener("load", check); window.addEventListener("resize", check);
all("img", inner).forEach(function(i){ i.addEventListener("load", check); });
if (btn) btn.addEventListener("click", function(){
var open = !box.classList.contains("open");
box.classList.toggle("open", open);
btn.querySelector("span").textContent = open ? btn.getAttribute("data-less") : btn.getAttribute("data-more");
if (!open) box.scrollIntoView({ behavior: "smooth", block: "start" });
});
});
}

/* ---------- swipe hints on horizontal rows ---------- */
function wireRailHints(){
all(".assure.is-rail, .trustsec.trust--rail .trust, .pvids, .prevs").forEach(function(el){
if (el.dataset.hinted) return; el.dataset.hinted = "1";
el.classList.add("xrail");
var arrow = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 8h10M9 4l4 4-4 4"/></svg>';
var h = document.createElement("div");
h.className = "rhint";
h.innerHTML = '<button type="button" class="rhint__btn" data-d="-1" aria-label="Scroll left"><svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 3L5 8l5 5"/></svg></button>' +
'<span class="rhint__bar"><i></i></span>' +
'<span class="rhint__lab"><span class="hand m-only">\u{1F446}</span><span class="m-only">Swipe for more</span><span class="d-only">Scroll for more</span>' + arrow + '</span>' +
'<button type="button" class="rhint__btn" data-d="1" aria-label="Scroll right"><svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 3l5 5-5 5"/></svg></button>';
el.parentNode.insertBefore(h, el.nextSibling);
var bar = h.querySelector(".rhint__bar i"), btns = all(".rhint__btn", h);
function paint(){
var max = el.scrollWidth - el.clientWidth, more = max > 6;
h.style.display = more ? "" : "none";
el.classList.toggle("has-more", more);
if (!more) return;
var x = el.scrollLeft, frac = el.clientWidth / el.scrollWidth;
bar.parentNode.style.setProperty("--w", (frac * 100).toFixed(1) + "%");
bar.style.setProperty("--x", ((x / max) * (1 - frac) / frac * 100).toFixed(1) + "%");
el.classList.toggle("at-end", x >= max - 6);
el.classList.toggle("mid", x > 6 && x < max - 6);
btns[0].disabled = x < 6; btns[1].disabled = x >= max - 6;
var mid = el.getBoundingClientRect().left + Math.min(el.clientWidth, 260) / 2;
[].forEach.call(el.children, function(c){ var b = c.getBoundingClientRect(); c.classList.toggle("in-focus", el.classList.contains("assure") && b.left <= mid && b.right >= mid); });
}
btns.forEach(function(b){ b.addEventListener("click", function(){
var first = el.children[0], step = first ? first.getBoundingClientRect().width + 10 : 260;
el.scrollBy({ left: step * parseInt(b.getAttribute("data-d"), 10), behavior: "smooth" });
h.classList.add("used");
}); });
var used = function(){ h.classList.add("used"); };
el.addEventListener("touchstart", used, { passive:true });
el.addEventListener("pointerdown", used);
el.addEventListener("scroll", paint, { passive:true });
window.addEventListener("resize", paint);
paint(); setTimeout(paint, 600);
if (!reduce && "IntersectionObserver" in window && !el.hasAttribute("data-autorail")) {
var po = new IntersectionObserver(function(es){ es.forEach(function(e){
if (!e.isIntersecting || h.classList.contains("used")) return;
po.disconnect();
if (el.scrollWidth - el.clientWidth > 6) { el.classList.add("peek"); setTimeout(function(){ el.classList.remove("peek"); }, 1700); }
}); }, { threshold: .6 });
po.observe(el);
}
});
}

/* ---------- highlight bar rotation ---------- */
function wireHl(){
all("[data-hl]").forEach(function(bar){
if (bar.dataset.wired) return; bar.dataset.wired = "1";
var items = all(".hlbar__i", bar); if (items.length < 2 || reduce) return;
var k = 0, ms = parseInt(bar.getAttribute("data-hl"), 10) || 3000;
setInterval(function(){
var cur = items[k]; k = (k + 1) % items.length; var nx = items[k];
cur.classList.remove("on"); cur.classList.add("out");
nx.classList.remove("out"); nx.style.transition = "none"; nx.style.transform = "translateY(100%)"; void nx.offsetWidth;
nx.style.transition = ""; nx.style.transform = ""; nx.classList.add("on");
setTimeout(function(){ cur.classList.remove("out"); }, 600);
}, ms);
});
}

/* ---------- delivery countdown in the highlight bar ---------- */
function wireEta(){
all("[data-eta]").forEach(function(el){
if (el.dataset.wired) return; el.dataset.wired = "1";
var txt = el.querySelector("[data-eta-txt]");
var cut = parseInt(el.getAttribute("data-cut"), 10) || 15;
var dmin = parseInt(el.getAttribute("data-min"), 10) || 1, dmax = parseInt(el.getAttribute("data-max"), 10) || 2;
function gulfNow(){ var n = new Date(); return new Date(n.getTime() + n.getTimezoneOffset() * 60000 + 4 * 3600000); }
function fmt(d){ return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" }); }
function paint(){
var g = gulfNow(), c = new Date(g); c.setHours(cut, 0, 0, 0);
var base = new Date(g); if (g >= c) base.setDate(base.getDate() + 1);
var a = new Date(base); a.setDate(a.getDate() + dmin);
var b = new Date(base); b.setDate(b.getDate() + dmax);
var when = dmin === dmax ? fmt(a) : fmt(a) + " to " + fmt(b);
if (g < c) {
var m = Math.max(1, Math.round((c - g) / 60000)), h = Math.floor(m / 60);
txt.innerHTML = "Order in <b>" + (h ? h + "h " : "") + (m % 60) + "m</b>, get it " + when;
} else txt.innerHTML = "Order now, get it <b>" + when + "</b>";
}
paint(); setInterval(paint, 30000);
});
}

/* ---------------- boot ---------------- */
  wire(); wireRail(); wireRevs(); wirePdp(); wireAutoRails(); wireSlideshows(); wireDrag(); wireVideos(); wireClamp(); wireRailHints(); wireHl(); wireEta();
  var hero = $("hero");
  if (hero) requestAnimationFrame(function(){ requestAnimationFrame(function(){ hero.classList.add("lifted"); }); });
  frame();

  /* theme editor: re-run when sections reload */
  document.addEventListener("shopify:section:load", function(){ annH(); wire(); wireRail(); wireRevs(); wireAutoRails(); wireSlideshows(); wireDrag(); wireVideos(); wireClamp(); wireRailHints(); wireHl(); wireEta(); var h = $("hero"); if (h) h.classList.add("lifted"); frame(); });
})();

/* wy fly-to-cart */(function(){if(window.__wyFly)return;window.__wyFly=1;var last=null,lastT=0,SEL="[data-add],[data-buy],[data-addform],[data-addsticky]",RM=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;document.addEventListener("click",function(e){var b=e.target.closest&&e.target.closest(SEL);if(b){last=b;lastT=Date.now()}},true);document.addEventListener("submit",function(e){var b=e.target.querySelector&&e.target.querySelector("[data-addform]");if(b){last=b;lastT=Date.now()}},true);var st=document.createElement("style");st.textContent="@keyframes wyBump{0%{transform:scale(1)}30%{transform:scale(1.3)}60%{transform:scale(.92)}100%{transform:scale(1)}}.wy-bump{animation:wyBump .55s ease}.wy-fly{position:fixed;z-index:99999;pointer-events:none;border-radius:14px;object-fit:cover;background:#fff;box-shadow:0 12px 30px rgba(31,61,91,.35);will-change:transform,opacity}";document.head.appendChild(st);function srcImg(b){if(b.hasAttribute("data-add")){var n=b;for(var i=0;i<7&&n;i++){n=n.parentElement;if(n){var im=n.querySelector("img");if(im)return im}}}return document.getElementById("pdpImg")}function target(){var c=document.getElementById("cartCount");return(c&&c.closest("a"))||c}function bump(t){t.classList.remove("wy-bump");void t.offsetWidth;t.classList.add("wy-bump")}function fly(b){var t=target();if(!t)return;if(RM||!document.body.animate){bump(t);return}var tr=t.getBoundingClientRect(),tx=tr.left+tr.width/2,ty=tr.top+tr.height/2;if(tr.bottom<0||tr.width===0){tx=window.innerWidth-40;ty=24}var im=srcImg(b),sr=(im||b).getBoundingClientRect();if(sr.bottom<0||sr.top>window.innerHeight||sr.width===0)sr=b.getBoundingClientRect();var size=Math.round(Math.min(130,Math.max(56,Math.min(sr.width,sr.height)*.7))),sx=sr.left+sr.width/2,sy=sr.top+sr.height/2,el;if(im&&(im.currentSrc||im.src)){el=document.createElement("img");el.src=im.currentSrc||im.src;el.alt=""}else{el=document.createElement("div");el.style.background="#1F3D5B";el.style.borderRadius="50%"}el.className="wy-fly";el.style.width=size+"px";el.style.height=size+"px";el.style.left=(sx-size/2)+"px";el.style.top=(sy-size/2)+"px";document.body.appendChild(el);var dx=tx-sx,dy=ty-sy,a=el.animate([{transform:"translate(0px,0px) scale(1)",opacity:1},{transform:"translate("+(dx*.45)+"px,"+(dy*.45-90)+"px) scale(.7)",opacity:1,offset:.5},{transform:"translate("+dx+"px,"+dy+"px) scale(.15)",opacity:.5}],{duration:850,easing:"cubic-bezier(.5,0,.3,1)"});a.onfinish=function(){el.remove();bump(t)}}var of=window.fetch;window.fetch=function(u){var p=of.apply(this,arguments);try{var url=typeof u==="string"?u:(u&&u.url)||"";if(url.indexOf("/cart/add")>-1){p.then(function(r){if(r.ok&&last&&Date.now()-lastT<8000){var b=last;last=null;fly(b)}},function(){})}}catch(e){}return p}})();

/* ---------- wy search popup (header search icon opens a small popup) ---------- */
(function () {
  if (window.__wySP) return; window.__wySP = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var CHIPS = ["charger", "cable", "stand", "magnetic", "laptop"];
  var css =
    ".wysp-ov{position:fixed;inset:0;z-index:9990;background:rgba(15,28,42,.12);opacity:0;visibility:hidden;transition:opacity .2s,visibility .2s}" +
    ".wysp-ov.on{opacity:1;visibility:visible;transition:opacity .2s,visibility 0s}" +
    ".wysp{position:absolute;z-index:9991;width:390px;max-width:calc(100vw - 32px);box-sizing:border-box;background:#fff;border:1px solid #E6E3DE;border-radius:16px;box-shadow:0 18px 44px rgba(31,61,91,.18);padding:14px;opacity:0;visibility:hidden;transform:translateY(-6px) scale(.98);transform-origin:top right;transition:opacity .18s ease,transform .18s ease,visibility .18s}" +
    ".wysp.on{opacity:1;visibility:visible;transform:none;transition:opacity .18s ease,transform .18s ease,visibility 0s}" +
    ".wysp *{box-sizing:border-box}" +
    ".wysp-f{display:flex;align-items:center;gap:8px;background:#F7F7F7;border:1px solid #E6E3DE;border-radius:12px;padding:0 5px 0 12px;height:46px;margin:0;color:#5C6A78}" +
    ".wysp-f:focus-within{border-color:#1F3D5B;background:#fff}" +
    ".wysp-f input[type=search]{flex:1;min-width:0;border:0;outline:0;background:transparent;font:inherit;font-size:15px;color:#1F3D5B;height:100%;padding:0;-webkit-appearance:none;appearance:none}" +
    ".wysp-f input::-webkit-search-cancel-button{display:none}" +
    ".wysp-go{border:0;background:#1F3D5B;color:#fff;border-radius:9px;height:36px;padding:0 14px;font:inherit;font-size:13px;font-weight:600;cursor:pointer;flex:none}" +
    ".wysp-go:hover{opacity:.9}" +
    ".wysp-hd{display:flex;align-items:center;justify-content:space-between;margin:0 2px 10px}" +
    ".wysp-t{font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#5C6A78}" +
    ".wysp-x{border:0;background:transparent;color:#5C6A78;width:28px;height:28px;border-radius:8px;cursor:pointer;display:grid;place-items:center;padding:0}" +
    ".wysp-x:hover{background:#F0F0F0;color:#1F3D5B}" +
    ".wysp-chips{display:flex;flex-wrap:wrap;gap:6px;margin-top:12px}" +
    ".wysp-chip{font-family:'IBM Plex Mono',monospace;font-size:11.5px;color:#5C6A78;background:#fff;border:1px solid #E6E3DE;border-radius:99px;padding:6px 12px;text-decoration:none;cursor:pointer}" +
    ".wysp-chip:hover{border-color:#1F3D5B;color:#1F3D5B}" +
    ".wysp-res{margin-top:10px;max-height:min(300px,50vh);overflow:auto;overscroll-behavior:contain}" +
    ".wysp-res:empty{display:none}" +
    ".wysp-i{display:flex;align-items:center;gap:12px;padding:8px;border-radius:10px;text-decoration:none;color:#1F3D5B}" +
    ".wysp-i:hover,.wysp-i.act{background:#F7F7F7}" +
    ".wysp-i img,.wysp-i .ph{width:48px;height:48px;border-radius:8px;object-fit:cover;background:#F0F0F0;flex:none}" +
    ".wysp-i .n{font-size:13.5px;font-weight:600;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}" +
    ".wysp-i .p{font-family:'IBM Plex Mono',monospace;font-size:12px;margin-top:3px;color:#1F3D5B}" +
    ".wysp-i .p s{color:#9AA4AE;margin-left:6px}" +
    ".wysp-all:empty{display:none}" +
    ".wysp-all{display:block;margin-top:6px;padding:10px 8px;border-top:1px solid #F0F0F0;font-size:13px;font-weight:600;color:#1F3D5B;text-decoration:none}" +
    ".wysp-all:hover{text-decoration:underline}" +
    ".wysp-msg{padding:12px 8px;font-size:13px;color:#5C6A78}" +
    "@media (max-width:600px){.wysp{left:16px!important;right:16px!important;width:auto;max-width:none}}" +
    "@media (prefers-reduced-motion:reduce){.wysp,.wysp-ov{transition:none}}";
  var st = document.createElement("style"); st.textContent = css; document.head.appendChild(st);

  var ICON = '<svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8" fill="none"><circle cx="11" cy="11" r="7"></circle><path d="M16.5 16.5L21 21"></path></svg>';
  var ov = document.createElement("div"); ov.className = "wysp-ov";
  var box = document.createElement("div"); box.className = "wysp";
  box.setAttribute("role", "dialog"); box.setAttribute("aria-label", "Search");
  box.innerHTML =
    '<div class="wysp-hd"><span class="wysp-t">Search the store</span>' +
    '<button type="button" class="wysp-x" aria-label="Close search"><svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none"><path d="M6 6l12 12M18 6L6 18"></path></svg></button></div>' +
    '<form class="wysp-f" action="' + ROOT + 'search" method="get" role="search">' + ICON +
    '<input type="hidden" name="type" value="product">' +
    '<input type="search" name="q" placeholder="Search chargers, cables, stands" autocomplete="off" enterkeyhint="search" aria-label="Search">' +
    '<button type="submit" class="wysp-go">Search</button></form>' +
    '<div class="wysp-chips">' + CHIPS.map(function (c) { return '<a class="wysp-chip" href="' + ROOT + 'search?type=product&q=' + encodeURIComponent(c) + '">' + c + '</a>'; }).join("") + '</div>' +
    '<div class="wysp-res" aria-live="polite"></div><a class="wysp-all"></a>';
  document.body.appendChild(ov); document.body.appendChild(box);

  var input = box.querySelector("input[type=search]"), res = box.querySelector(".wysp-res"),
      chips = box.querySelector(".wysp-chips"), allA = box.querySelector(".wysp-all"), opener = null, timer = null, seq = 0, act = -1;

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function money(v) {
    var n = parseFloat(v); if (isNaN(n)) return "";
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "AED";
    return cur + " " + (n % 1 ? n.toFixed(2) : n.toFixed(0));
  }
  function place() {
    if (!opener) return;
    var r = opener.getBoundingClientRect();
    box.style.top = (r.bottom + window.scrollY + 10) + "px";
    box.style.right = Math.max(16, document.documentElement.clientWidth - r.right - 8) + "px";
    box.style.left = "auto";
  }
  function open(a) {
    opener = a; place();
    ov.classList.add("on"); box.classList.add("on");
    box.offsetWidth; try { input.focus({ preventScroll: true }); input.select(); } catch (e) {}
    setTimeout(function () { if (document.activeElement !== input) input.focus(); }, 60);
  }
  function close() {
    if (!box.classList.contains("on")) return;
    ov.classList.remove("on"); box.classList.remove("on");
    if (opener) try { opener.focus({ preventScroll: true }); } catch (e) {}
  }
  function setAct(i) {
    var items = res.querySelectorAll(".wysp-i");
    act = items.length ? (i + items.length) % items.length : -1;
    items.forEach(function (el, k) { el.classList.toggle("act", k === act); });
  }
  function search(q) {
    var my = ++seq; act = -1;
    if (!q) { res.innerHTML = ""; allA.textContent = ""; chips.style.display = ""; return; }
    fetch(ROOT + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (my !== seq) return;
        var p = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        var all = ROOT + "search?type=product&q=" + encodeURIComponent(q);
        chips.style.display = p.length ? "none" : "";
        allA.textContent = "";
        if (!p.length) { res.innerHTML = '<div class="wysp-msg">No products found for “' + esc(q) + '”.</div>'; return; }
        res.innerHTML = p.map(function (x) {
          var img = x.featured_image && x.featured_image.url || x.image || "";
          if (img) img += (img.indexOf("?") > -1 ? "&" : "?") + "width=120";
          var cmp = parseFloat(x.compare_at_price_max), pr = parseFloat(x.price);
          return '<a class="wysp-i" href="' + esc(x.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="ph"></span>') +
            '<span><span class="n">' + esc(x.title) + '</span><span class="p">' + money(x.price) +
            (cmp > pr ? '<s>' + money(cmp) + '</s>' : '') + '</span></span></a>';
        }).join("");
        allA.href = all; allA.textContent = "View all results for “" + q + "” →";
      })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('a[href$="/search"].icn, [data-search-open]');
    if (!a || box.contains(a)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    box.classList.contains("on") && opener === a ? close() : open(a);
  });
  ov.addEventListener("click", close);
  box.querySelector(".wysp-x").addEventListener("click", close);
  input.addEventListener("input", function () {
    clearTimeout(timer); var q = input.value.trim();
    timer = setTimeout(function () { search(q); }, 220);
  });
  input.addEventListener("keydown", function (e) {
    var items = res.querySelectorAll(".wysp-i");
    if (e.key === "ArrowDown" && items.length) { e.preventDefault(); setAct(act + 1); }
    else if (e.key === "ArrowUp" && items.length) { e.preventDefault(); setAct(act - 1); }
    else if (e.key === "Enter" && act > -1 && items[act]) { e.preventDefault(); window.location.href = items[act].href; }
  });
  box.querySelector("form").addEventListener("submit", function (e) {
    if (!input.value.trim()) { e.preventDefault(); input.focus(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  window.addEventListener("resize", place);
})();
